module.exports = __webpack_public_path__ + "static/media/courierconnect.afa70ac9.svg";